export default {
    groups: [
        {
            id: 1,
            label: 'Условия поиска',
            collapsed: false,
        },
    ],
    components: [
        // GROUP 1
        {
            name: 'history-emp-deps',
            groupId: 1,
            size: [1, 1],
            fieldNameId: 'who_id',
            fieldNameText:'who_name',
        },
        {
            name: 'history-tab-groups',
            groupId: 1,
            size: [1, 1],
            fieldNameId: 'where_id',
            fieldNameText:'where_name',
        },
        {
            name: 'history-date',
            groupId: 1,
            size: [1, 1],
        },
        {
            name: 'history-operation',
            groupId: 1,
            size: [1, 1],
        },
        {
            name: 'history-btn-search',
            groupId: 1,
            size: [1, 1],
        },

        // GROUP Договорной контекст
        {
            name: 'ctx-dog-orgs',
            groupId: 2,
            size: [6, 2],
        },
        {
            name: 'ctx-dog-dogs',
            groupId: 2,
            size: [6, 1],
        },
        {
            name: 'ctx-dog-objs',
            groupId: 2,
            size: [6, 2],
        },
        {
            name: 'ctx-dog-pnts',
            groupId: 2,
            size: [6, 1],
        },
        // GROUP Результаты
        {
            name: 'history-grid-results',
            groupId: 6,
            size: [6, 6],
        },
    ],
};
